function Hitbox(width, height) {

    this.name = 'hitbox';

    this.width = width;
    this.height = height;
}

export {Hitbox};
